import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Button } from './Button';
export function FAQ() {
  const faqs = [{
    q: '¿Es para personas con diabetes tipo 2?',
    a: 'Sí, absolutamente. Todas las recetas están pensadas para mantener los niveles de glucosa estables, siendo ideales para personas con diabetes tipo 2.'
  }, {
    q: '¿Sirve para prediabetes?',
    a: 'Sí, es perfecta para prediabetes. Te ayudará a mejorar tu alimentación sin sentir que estás a dieta, previniendo picos de glucosa.'
  }, {
    q: '¿Sirve para resistencia a la insulina?',
    a: 'Totalmente. Las recetas utilizan ingredientes de bajo índice glucémico que son fundamentales para manejar la resistencia a la insulina.'
  }, {
    q: '¿Las recetas usan ingredientes difíciles?',
    a: 'No. Todo está pensado con ingredientes que podés conseguir fácilmente en dietéticas o supermercados de Argentina.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Una vez confirmado el pago, recibirás un correo electrónico inmediatamente con el enlace para acceder a todo el contenido.'
  }, {
    q: '¿Es digital?',
    a: 'Sí, es un producto 100% digital. Podés leerlo en tu celular, tablet o computadora, o imprimirlo si lo preferís.'
  }, {
    q: '¿Los bonus están incluidos?',
    a: 'Sí, al acceder hoy te llevás la Enciclopedia + los 3 bonus exclusivos por el mismo precio.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, tenés 7 días de garantía de satisfacción. Si no te gusta, te devolvemos el dinero sin hacer preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-32 px-6 bg-white" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900" data-id="element-23">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-gray-200 rounded-2xl overflow-hidden" data-id="element-25">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-gray-50 transition-colors" data-id="element-26">
                <span className="font-bold text-gray-900 pr-8" data-id="element-27">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-28" />
              </button>
              <AnimatePresence data-id="element-29">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                    <div className="p-6 pt-0 text-gray-600 border-t border-gray-100 bg-gray-50" data-id="element-31">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-16" data-id="element-32">
          <Button data-id="element-33">QUIERO VOLVER A DISFRUTAR LA COMIDA</Button>
        </motion.div>
      </div>
    </section>;
}